import { Link, useNavigate } from "react-router-dom";
import styles from "./NotFoundPage.module.css";
import SoftindexLogo from "../../assets/images/softindex-website-logo.webp";

export default function NotFoundPage() {
  const navigate = useNavigate();

  const handleGoHome = () => {
    navigate("/");
  };

  const handleGoBack = () => {
    navigate(-1);
  };

  return (
    <div className={styles.notFoundPage}>
      <div className={styles.container}>
        <div className={styles.logoSection}>
          <img
            src={SoftindexLogo}
            alt="Softindex Logo"
            className={styles.logo}
          />
        </div>

        <div className={styles.content}>
          <div className={styles.errorCode}>404</div>
          <h1 className={styles.title}>Page Not Found</h1>
          <p className={styles.subtitle}>
            Sorry, we couldn&apos;t find the page you&apos;re looking for. The
            page might have been moved, deleted, or you entered the wrong URL.
          </p>

          <div className={styles.actionButtons}>
            <button
              type="button"
              onClick={handleGoHome}
              className={styles.primaryButton}
            >
              <svg
                width="20"
                height="20"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                className={styles.buttonIcon}
                aria-hidden
              >
                <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" />
                <polyline points="9,22 9,12 15,12 15,22" />
              </svg>
              Go Home
            </button>
            <button
              type="button"
              onClick={handleGoBack}
              className={styles.secondaryButton}
            >
              <svg
                width="20"
                height="20"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                className={styles.buttonIcon}
                aria-hidden
              >
                <path d="M19 12H5M12 19l-7-7 7-7" />
              </svg>
              Go Back
            </button>
          </div>

          <div className={styles.helpSection}>
            <h3 className={styles.helpTitle}>Need Help?</h3>
            <p className={styles.helpText}>
              If you believe this is an error, please contact our support team
              or try one of these popular pages:
            </p>
            <div className={styles.quickLinks}>
              <Link to="/" className={styles.quickLink}>
                Dashboard
              </Link>
              <Link to="/products" className={styles.quickLink}>
                Products
              </Link>
              <Link to="/settings" className={styles.quickLink}>
                Settings
              </Link>
              <Link to="/support" className={styles.quickLink}>
                Support
              </Link>
            </div>
          </div>

          <div className={styles.footer}>
            <p className={styles.footerText}>
              Having trouble?{" "}
              <a
                href="https://softindex.ro/contact"
                className={styles.footerLink}
              >
                Contact our support team
              </a>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
